import { CityState, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementQuickInfo extends Layout {
    destCityState: CityState;
    labelError: Label;
    labelId: Label;
    originCityState: CityState;
    panelMovementQuickInfo: Panel;
    sourceMovementStops: DataSource;
    textboxCustomername: Textbox;
    textboxDestPickupWindow: Textbox;
    textboxDestStoplocationName: Textbox;
    textboxOrderscommodity: Textbox;
    textboxOriginPickupWindow: Textbox;
    textboxOriginStoplocationName: Textbox;
    textboxStatus: Textbox;
}
